import { Box, Breadcrumbs, Link, Stack, Tab, Tabs, Typography } from '@mui/material';
import { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { useDispatch, useSelector } from 'react-redux';
import logo from '../../assets/images/management-framework-blue.svg';
import { selectFramework, selectSelectedFramework } from '../../redux/reducers/frameworkReducer';
import { selectSelectedOrganization } from '../../redux/reducers/organizationReducer';
import ManagementControls from './ManagementControls';
import OperationalControls from './OperationalControls';
import SOAControls from './SOAControls';

function TabbedFrameworkView() {
  const { t } = useTranslation();
  const dispatch = useDispatch();
  const selectedOrganization = useSelector(selectSelectedOrganization);
  const framework = useSelector(selectSelectedFramework);

  const TabValues = Object.freeze({
    MANAGEMENT: 'management',
    OPERATIONAL: 'operational',
    SOA: 'soa',
    valueOf(index) {
      switch (index) {
        case 2:
          return TabValues.SOA;
        case 1:
          return TabValues.OPERATIONAL;
        case 0:
        default:
          return TabValues.MANAGEMENT;
      }
    },
    indexOf(value) {
      switch (value) {
        case TabValues.SOA:
          return 2;
        case TabValues.OPERATIONAL:
          return 1;
        case TabValues.MANAGEMENT:
        default:
          return 0;
      }
    },
  });

  const [selectedTab, setSelectedTab] = useState(TabValues.MANAGEMENT);

  const handleChange = (_, index) => {
    setSelectedTab(TabValues.valueOf(index));
  };

  useEffect(() => () => dispatch(selectFramework('')), []);

  const renderTabContents = (tab) => {
    switch (tab) {
      case TabValues.SOA:
        return <SOAControls />;
      case TabValues.OPERATIONAL:
        return <OperationalControls />;
      case TabValues.MANAGEMENT: // Intentional fallthrough
      default:
        return <ManagementControls />;
    }
  };

  return (
    <>
      <Box sx={{ maxWidth: '1200px' }}>
        <Stack spacing={2}>
          <Stack direction="row" alignContent="center" spacing={1}>
            <img src={logo} width="32px" alt="" />
            <Breadcrumbs aria-label="breadcrumb">
              <Typography variant="overline">{selectedOrganization.name.toUpperCase()}</Typography>
              <Link
                variant="overline"
                underline="hover"
                component="button"
                onClick={() => dispatch(selectFramework(''))}
              >
                {t('framework.viewTitle').toUpperCase()}
              </Link>
              <Typography variant="overline">{framework.title.toUpperCase()}</Typography>
            </Breadcrumbs>
          </Stack>
          <Tabs
            sx={{ maxWidth: 'lg' }}
            variant="fullWidth"
            value={TabValues.indexOf(selectedTab)}
            onChange={handleChange}
          >
            <Tab variant="tab" label={t('framework.tabs.management')} />
            <Tab variant="tab" label={t('framework.tabs.operational')} />
            <Tab variant="tab" label={t('framework.tabs.soa')} />
          </Tabs>
        </Stack>
      </Box>
      {renderTabContents(selectedTab)}
    </>
  );
}

export default TabbedFrameworkView;
